module.exports = __webpack_public_path__ + "static/media/developed_by_acoer.068d39f6.svg";